import React from 'react';
import QRCode from 'react-qr-code';
import { systemCode, xs_languageCode } from '../../..';
import { getCurrencyValue } from '../../../data/utils/getCurrencyValue';
import { oddToString } from '../../../data/utils/oddToString';
import { getBarcode } from '../../../data/utils/getBarcode';
import { getHiddenTicket } from '../../../data/utils/getHiddenTicket';
import { convertToDecimalWithPrecision } from '../../../data/utils/convertToDecimalWithPrecision';
import { truncateDoubleTo } from '../../../data/utils/truncateDoubleTo';
import { getBarcodeIdTicket } from '../../../data/utils/getBarcodeIdTicket';
import { getLabel } from '../../../data/labels';
import { getTaxPercentage, taxesEnabled } from '../../purchase-service';


function BorderedTicketFooter(props) {
	const ticketData = props.ticketData;
	const conf = props.conf;
	const frontendType = props.frontendType;
	const aamsEnviroment = props.aamsEnviroment; 
	const user = props.user;
	const terminalCopy = props.terminalCopy;
	const skinProperties = props.skinProperties;
	let accountId = user != null? user.accountId : '';
	accountId = accountId == null? '' : accountId;
	const isTerminal = frontendType === 'TERMINAL' || frontendType === 'SELF-CASHIER';
	const purchaseType = ticketData.purchaseType;
	const printableTotalAmount = getCurrencyValue(ticketData.amount, conf.cs.m, conf.cs.nd, conf.cs.ct);
	
	const bonus = ticketData.bonus;
	const totalWin = ticketData.win;
	const printableBonus = getCurrencyValue(bonus, conf.cs.m, conf.cs.nd, conf.cs.ct);
	const winningNoBonus = getCurrencyValue(totalWin - bonus, conf.cs.m, conf.cs.nd, conf.cs.ct);
	const printableTotalWin = getCurrencyValue(totalWin, conf.cs.m, conf.cs.nd, conf.cs.ct);
	const maxWinAmount = getCurrencyValue(5000000, conf.cs.m, conf.cs.nd, conf.cs.ct);
	let totalCentOdd = 100;
	if(ticketData.purchaseType != 'systembets'){
		let totalOdd = 1;
		for(let k in ticketData.events){
			let selection = ticketData.events[k];
			for(let kb in selection.bets){
				let bet = selection.bets[kb];
				totalOdd = totalOdd * convertToDecimalWithPrecision(bet.odd, 19, 6)/100;
				totalOdd = convertToDecimalWithPrecision(totalOdd, 19, 6);
			}
		}
		totalOdd = truncateDoubleTo(totalOdd, 2) + "";
		totalOdd = totalOdd.replace(/,/g, '');
		totalOdd = totalOdd.replace(/\./g, '');
		totalCentOdd = parseInt(totalOdd);
	}

	
	const bonusLabel = bonus > 0? getLabel('printer.plain_ticket.footer.bonus').replaceAll(":", "") : '' ;

	
	function generateIdTicketWithBars(idTicket){
		let idTicketToShow = idTicket;
		if(terminalCopy && skinProperties && skinProperties.hideTerminalTicket){
			idTicketToShow = getHiddenTicket(idTicketToShow);
		}
		let res = '';
		let tokens = idTicketToShow.match(/.{1,4}/g);
		res = tokens.join("-");
		return res;
	}
	
	
	let linkTemplate = conf.qrct;
	if(linkTemplate != null && linkTemplate.length > 0){
		linkTemplate= linkTemplate.replace(/{{TICKET}}/g, ticketData.idTicket);
		linkTemplate = linkTemplate.replace(/{{LANG}}/g, xs_languageCode);
		linkTemplate = linkTemplate.replace(/{{SYSTEM_CODE}}/g, systemCode);
	}
	
	
	
	let taxesAdviceSystem = null;
	if(ticketData.purchaseType === 'systembets' && getLabel('ticket.system.advice_taxes').length > 0 && taxesEnabled()){
		taxesAdviceSystem = getLabel('ticket.system.advice_taxes');
		taxesAdviceSystem = taxesAdviceSystem.replace(/{{TAXES_AMOUNT}}/g, getTaxPercentage());
	}

	let totalAmountLabelTaxedStake = null;
	let grossTotalAmount = null;
	let showStakeTaxed = false;
	if(ticketData.taxOnStake && ticketData.taxOnStake > 0){
		totalAmountLabelTaxedStake = getLabel('ticket.general.taxed_stake');
		totalAmountLabelTaxedStake = totalAmountLabelTaxedStake.replace(/{{PERCENTAGE}}/g, (conf.cs.tb / 100 + '%') );
		grossTotalAmount = ticketData.taxOnStake + ticketData.amount;
		grossTotalAmount = getCurrencyValue(grossTotalAmount, conf.cs.m, conf.cs.nd, conf.cs.ct);
		showStakeTaxed = true;
	}
	
	const logoBottom = conf.tad && conf.tad.lob;
	const imgBase64CustomerLogo = logoBottom?  props.customerLogo : null;	
	const ticketOnHeader = conf.tad && conf.tad.idh;
	let lastCharReprint = '';
	if(props.printAgainTerminalRec){
		let label = getLabel('printer.bordered_ticket.footer.id');
		lastCharReprint = label.substr(label.length - 1);
	}

	return (
	<div className="div-table border-bottom">
		<div className="metadata-subtable">
			<div className="metadata-row">
				<div className="metadata-key">{getLabel('printer.plain_ticket.footer.total_amount')}</div>
				<div className="metadata-value">{grossTotalAmount != null? grossTotalAmount : printableTotalAmount}</div>
				<div className="clear"></div>
			</div>
		 {
			 showStakeTaxed && (
					<div className="metadata-row">
						<div className="metadata-key">{totalAmountLabelTaxedStake}</div>
						<div className="metadata-value">{printableTotalAmount}</div>
						<div className="clear"></div>
					</div>
			 )
		 }

		{
			purchaseType === 'systembets' ? (
				<div className="metadata-row">
					<div className="metadata-key">{getLabel('printer.bordered_ticket.footer.total_combs')}</div>
					<div className="metadata-value">{ticketData.totCombs}</div>
					<div className="clear"></div>
				</div>	
			)
			:
			(
				<div className="metadata-row">
					<div className="metadata-key">{getLabel('printer.bordered_ticket.footer.total_odds')}</div>
					<div className="metadata-value">{oddToString(totalCentOdd)}</div>
					<div className="clear"></div>
				</div>
			)
		}
		{
			bonusLabel.length > 0 && (
				<div className="metadata-row">
					<div className="metadata-key">{bonusLabel}</div>
					{
						purchaseType !== 'systembets' && (
							<div className="metadata-value">{printableBonus}</div>
						)
					}
					<div className="clear"></div>
				</div>
			)
		}

		{
			ticketData.taxes > 0 &&  <>
			
				<div className="metadata-row">
					<div className="metadata-key">{getLabel('printer.bordered_ticket.footer.gross_winnings')}</div>
					<div className="metadata-value">{getCurrencyValue(ticketData.winPlusTaxes, conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
					<div className="clear"></div>
				</div>
				<div className="metadata-row">
					<div className="metadata-key">{getLabel('printer.plain_ticket.footer.tax')} {'(' + getTaxPercentage() + ')'}</div>
					<div className="metadata-value">{getCurrencyValue(ticketData.taxes, conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
					<div className="clear"></div>
				</div>

			</>
		}
		{
			taxesAdviceSystem && (
				<div className="text-container-aams">{taxesAdviceSystem}</div>
			)
		}
			<div className="metadata-row">
				<div className="metadata-key">{getLabel('printer.bordered_ticket.footer.potential_winnings')}</div>
				<div className="metadata-value potWin">{printableTotalWin}</div>
				<div className="clear"></div>
			</div>
			
			<div className="table-line"></div>
			
			{
				!ticketOnHeader && <>
					<div className="metadata-row">
					<div className="metadata-key">{getLabel('printer.bordered_ticket.footer.id') + lastCharReprint.toUpperCase()}</div>
					<div className="metadata-value">{generateIdTicketWithBars(ticketData.idTicket)}</div>
					<div className="clear"></div>
					</div>
					<div className="table-line"></div>	
				</>
			}

			
			
			{
				(isTerminal && !terminalCopy) 
				 	&& (
				 			<div className="barcode-container"> 
				 				<img style={{ height: "50px", width:"100%"}} src={getBarcode(getBarcodeIdTicket(ticketData.idTicket, props.printAgainTerminalRec), 1, false)} />
				 			</div>
				 	)
			}
			{
				linkTemplate && linkTemplate.length > 0 && <>
					<div className="qrcode-container" >
						<QRCode value={linkTemplate} size={90}  style={{"marginTop":'3%', "marginBottom":'3%'}} />
					</div>	
					<div className="table-line"></div>
				</>
			}
			{
				aamsEnviroment && <>
					{
						props.aamsLogo != null &&(
								<div className="aams-logo-container">
									<img src={props.aamsLogo} />
								</div>
						)
					}
					<div className="text-container-aams">
					La registrazione e l'esito della puntata effettuata possono essere verificati sul sito www.aams.it.
					<br/>
					Questo promemoria non è una ricevuta di gioco valida per la riscossione della vincita.
					</div>
				
					<div className="text-container-aams">
						Il gioco può causare dipendenza.
						<br/>
						Consulta le probabilità di vincita su www.aams.gov.it
						<br/>
						E' vietato il gioco ai minori di anni 18
					</div>
					
				</>
			}
			{
				
				imgBase64CustomerLogo != null && imgBase64CustomerLogo.length > 0  && (
						<div className="customer-logo-container footer">
							<img src={imgBase64CustomerLogo} />
						</div>
				)
			}
			{
				conf.tad?.fad?.[xs_languageCode] && <div className="text-container-aams">
					{conf.tad.fad[xs_languageCode]}
				</div>
			}
	
		</div>
	</div>
	
	);
	
}

export default BorderedTicketFooter;